import type { MixedDressingDetails } from '@sg/graphql-schema';

import { DRESSINGS } from '../../customization.machine.constants';

import type { Modification } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

export function getDressingPortionSize(
  modification: Modification,
  mixedDressingDetails: MixedDressingDetails[],
) {
  const { ingredient, quantity } = modification;

  if (!ingredient) {
    return 1;
  }

  const mixedDressingDetail = mixedDressingDetails.find(
    (dressingDetail) => dressingDetail.ingredientId === ingredient.id,
  );
  const dressingWeight = mixedDressingDetail?.weight;

  if (!dressingWeight) {
    return quantity;
  }

  return DRESSINGS.WEIGHT_PORTIONS_MAP[dressingWeight];
}
